import baseOptions from './baseOptions';
import buildDrillDown from '../../../buildDrillDown';
import abbreviateNumber from '../../../utils/abbreviateNumber';

// Bubble plots each dimension member as an (x, y) point sized by a third metric
// (z). series[0] = x, series[1] = y, series[2] = size (optional; uniform size
// when absent). Requires the highcharts-more module (already registered in
// Chart.tsx).
const bubble = ({
  title,
  openMenu,
  groupField,
  fieldType,
  chartDef,
  fontSize,
  formatMetric,
  xMetricId,
  yMetricId,
  sizeMetricId,
  xMetricName,
  yMetricName,
  sizeMetricName,
  dateScope,
}) => {
  const axisLabelFormatter = function () {
    const abbreviated = abbreviateNumber(this.value);
    if (abbreviated) {
      return abbreviated.abbreviated.toLowerCase();
    }
    return this.axis.defaultLabelFormatter.call(this);
  };

  return {
    ...baseOptions(formatMetric),
    chart: {
      ...baseOptions(formatMetric).chart,
      type: 'bubble',
      marginTop: 24,
      zoomType: 'xy',
      plotBorderWidth: 0,
    },
    title: {
      ...baseOptions(formatMetric).title,
      text: title,
    },
    legend: {
      ...baseOptions(formatMetric).legend,
      enabled: false,
    },
    xAxis: {
      title: {
        enabled: true,
        text: xMetricName,
        style: { fontSize },
      },
      labels: {
        style: { fontSize },
        formatter: axisLabelFormatter,
      },
    },
    yAxis: {
      title: {
        enabled: true,
        text: yMetricName,
        style: { fontSize },
      },
      labels: {
        style: { fontSize },
        formatter: axisLabelFormatter,
      },
    },
    plotOptions: {
      bubble: {
        minSize: '3%',
        maxSize: '18%',
        dataLabels: {
          enabled: true,
          format: '{point.name}',
          style: {
            color: 'var(--color-text-primary)',
            textOutline: 'none',
            fontWeight: 'normal',
            fontSize,
          },
        },
      },
      series: {
        allowPointSelect: true,
        point: {
          events: {
            click: function () {
              if (openMenu) {
                const { metricIds } = this.series.userOptions;
                openMenu(
                  metricIds,
                  buildDrillDown(
                    groupField,
                    fieldType,
                    this.name,
                    chartDef,
                    dateScope,
                  ),
                );
              } else {
                const { onDrillDown } = this.series.userOptions;
                if (!onDrillDown) {
                  alert('Coming soon...');
                  return;
                }
                onDrillDown(this.name);
              }
            },
          },
        },
      },
    },
    tooltip: {
      ...baseOptions(formatMetric).tooltip,
      shared: false,
      useHTML: true,
      pointFormatter: function () {
        const x = formatMetric({ metricId: xMetricId, value: this.x });
        const y = formatMetric({ metricId: yMetricId, value: this.y });
        const sizeRow = sizeMetricName
          ? `<span style="color: var(--color-text-muted);">${sizeMetricName}: </span><b>${formatMetric(
              { metricId: sizeMetricId, value: this.z },
            )}</b>`
          : '';
        // NOTE: Inline styles in Highcharts tooltips cannot use CSS variables.
        return (
          `<b>${this.name}</b><br/>` +
          `<span style="color: var(--color-text-muted);">${xMetricName}: </span><b>${x}</b><br/>` +
          `<span style="color: var(--color-text-muted);">${yMetricName}: </span><b>${y}</b>` +
          (sizeRow ? `<br/>${sizeRow}` : '')
        );
      },
    },
  };
};

export default bubble;
